import { render, staticRenderFns } from "./passWdResetTemp.vue?vue&type=template&id=52f90944&scoped=true"
import script from "./passWdResetTemp.vue?vue&type=script&lang=js"
export * from "./passWdResetTemp.vue?vue&type=script&lang=js"
import style0 from "./passWdResetTemp.vue?vue&type=style&index=0&id=52f90944&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f90944",
  null
  
)

export default component.exports